[
  {
    "ncm": "01012100",
    "uf": "MG",
    "excecao": "",
    "descricao": "Cavalos reprodutores,de raca pura",
    "aliquotaNacionalFederal": 13.45,
    "aliquotaImportadosFederal": 15.45,
    "aliquotaEstadual": 18,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "12011000",
    "uf": "MG",
    "excecao": "",
    "descricao": "Soja, mesmo triturada, para semeadura",
    "aliquotaNacionalFederal": 13.45,
    "aliquotaImportadosFederal": 15.45,
    "aliquotaEstadual": 18,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "22030000",
    "uf": "MG",
    "excecao": "",
    "descricao": "Cervejas de malte",
    "aliquotaNacionalFederal": 16.08,
    "aliquotaImportadosFederal": 28.76,
    "aliquotaEstadual": 25,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "22030000",
    "uf": "MG",
    "excecao": "01",
    "descricao": "Chope",
    "aliquotaNacionalFederal": 16.08,
    "aliquotaImportadosFederal": 28.76,
    "aliquotaEstadual": 25,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "01012100",
    "uf": "RJ",
    "excecao": "",
    "descricao": "Cavalos reprodutores,de raca pura",
    "aliquotaNacionalFederal": 13.45,
    "aliquotaImportadosFederal": 15.45,
    "aliquotaEstadual": 14,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "12011000",
    "uf": "RJ",
    "excecao": "",
    "descricao": "Soja, mesmo triturada, para semeadura",
    "aliquotaNacionalFederal": 13.45,
    "aliquotaImportadosFederal": 15.45,
    "aliquotaEstadual": 22,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "22030000",
    "uf": "RJ",
    "excecao": "",
    "descricao": "Cervejas de malte",
    "aliquotaNacionalFederal": 15.17,
    "aliquotaImportadosFederal": 24.15,
    "aliquotaEstadual": 19,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "22030000",
    "uf": "RJ",
    "excecao": "01",
    "descricao": "Chope",
    "aliquotaNacionalFederal": 15.17,
    "aliquotaImportadosFederal": 24.15,
    "aliquotaEstadual": 19,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "01012100",
    "uf": "SP",
    "excecao": "",
    "descricao": "Cavalos reprodutores,de raca pura",
    "aliquotaNacionalFederal": 13.45,
    "aliquotaImportadosFederal": 15.45,
    "aliquotaEstadual": 18,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "12011000",
    "uf": "SP",
    "excecao": "",
    "descricao": "Soja, mesmo triturada, para semeadura",
    "aliquotaNacionalFederal": 13.45,
    "aliquotaImportadosFederal": 15.45,
    "aliquotaEstadual": 18,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "22030000",
    "uf": "SP",
    "excecao": "",
    "descricao": "Cervejas de malte",
    "aliquotaNacionalFederal": 13.91,
    "aliquotaImportadosFederal": 17.77,
    "aliquotaEstadual": 22,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  },
  {
    "ncm": "22030000",
    "uf": "SP",
    "excecao": "01",
    "descricao": "Chope",
    "aliquotaNacionalFederal": 13.91,
    "aliquotaImportadosFederal": 17.77,
    "aliquotaEstadual": 22,
    "aliquotaMunicipal": 0,
    "vigenciaInicio": "20/05/2026",
    "vigenciaFim": "30/06/2026",
    "tabela": "26.1.K"
  }
]
